__turbopack_context__.v({
  "badge": "style-module-scss-module__9nqJ1W__badge",
  "body": "style-module-scss-module__9nqJ1W__body",
  "btns": "style-module-scss-module__9nqJ1W__btns",
  "btns__item": "style-module-scss-module__9nqJ1W__btns__item",
  "btns__item__hideContainer": "style-module-scss-module__9nqJ1W__btns__item__hideContainer",
  "btns__item__more": "style-module-scss-module__9nqJ1W__btns__item__more",
  "btns__item__prem": "style-module-scss-module__9nqJ1W__btns__item__prem",
  "container": "style-module-scss-module__9nqJ1W__container",
  "container__disable": "style-module-scss-module__9nqJ1W__container__disable",
  "inner": "style-module-scss-module__9nqJ1W__inner",
  "inner__disable": "style-module-scss-module__9nqJ1W__inner__disable",
  "oldPrice": "style-module-scss-module__9nqJ1W__oldPrice",
  "perVacancy": "style-module-scss-module__9nqJ1W__perVacancy",
  "price": "style-module-scss-module__9nqJ1W__price",
  "title": "style-module-scss-module__9nqJ1W__title",
  "title__disable": "style-module-scss-module__9nqJ1W__title__disable",
});
